import { useTranslation } from 'react-i18next';
import { brandAssets } from './brandAssets';
import { BrandLockup } from './BrandLockup';

const features = [
  {
    id: 'secureAccess',
    path: 'M16.5 10.5V7a4.5 4.5 0 10-9 0v3.5m-.75 0h10.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75v-7.5a.75.75 0 01.75-.75z',
  },
  {
    id: 'centralized',
    path: 'M9 17.25v1.007a1.5 1.5 0 01-.4 1.02L7.5 20.75h9l-1.1-1.473a1.5 1.5 0 01-.4-1.02V17.25m2.25-12h-12A1.5 1.5 0 003.75 6.75v7.5A1.5 1.5 0 005.25 15.75h13.5a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5z',
  },
  {
    id: 'syncing',
    path: 'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182',
  },
] as const;

export function LoginBrandPanel() {
  const { t } = useTranslation('auth');
  return (
    <aside
      className="relative flex h-full min-h-screen flex-col overflow-hidden px-8 py-10 text-white lg:min-h-full lg:px-12 lg:py-12"
      style={{ backgroundColor: '#11110F' }}
    >
      <img
        src={brandAssets.loginBrandBg}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center"
      />
      {/* Keep copy readable over the photo */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'linear-gradient(105deg, rgba(17,17,15,0.92) 0%, rgba(17,17,15,0.78) 42%, rgba(17,17,15,0.45) 100%)',
        }}
        aria-hidden
      />

      <div className="relative">
        <BrandLockup tone="onDark" />
      </div>

      <div className="relative mt-8 max-w-xl lg:mt-10">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
          {t('brand.eyebrow')}
        </p>
        <h1 className="mt-3 text-[2.75rem] font-semibold leading-[1.05] tracking-[-0.03em] lg:text-[3.5rem]">
          {t('brand.headline')}
          <span className="mt-1 block" style={{ color: '#c45c26' }}>
            {t('brand.headlineAccent')}
          </span>
        </h1>
        <p className="mt-5 max-w-md text-lg leading-relaxed text-white/60">
          {t('brand.intro')}
        </p>
      </div>

      <ul className="relative mt-10 space-y-5 lg:mt-12">
        {features.map((feature) => (
          <li key={feature.id} className="flex gap-3.5">
            <span
              className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
              style={{ backgroundColor: 'rgba(196, 92, 38, 0.15)', color: '#c45c26' }}
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d={feature.path} />
              </svg>
            </span>
            <div>
              <p className="text-sm font-semibold text-white">
                {t(`brand.features.${feature.id}.title`)}
              </p>
              <p className="mt-0.5 text-sm leading-snug text-white/50">
                {t(`brand.features.${feature.id}.body`)}
              </p>
            </div>
          </li>
        ))}
      </ul>

      <div className="relative mt-auto hidden pt-10 lg:block">
        <div className="flex items-center gap-3">
          <span className="h-px w-8" style={{ backgroundColor: '#c45c26' }} />
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-white/35">
            {t('brand.tagline')}
          </p>
        </div>
      </div>
    </aside>
  );
}
